import { Product } from '@shared/generated'

export default function useCartItemTotal (
  product: Product,
  amount: number,
  oldPrice?: boolean,
) {
  // `priceOffer` is resolved client-side and can be missing before the cache
  // has computed it; fall back to the offers delivered by the server.
  const priceOffer = product.priceOffer
    ?? product.priceOffers?.find((offer) => offer?.isDefault)
    ?? product.priceOffers?.[0]

  if (!priceOffer) return null

  const price = oldPrice ? priceOffer.oldPrice : priceOffer.price

  // `count_multiplier` only exists on the client-resolved offer; derive the
  // same value from quant/quantAmount when falling back to a server offer.
  const quantAmount = (priceOffer.quantAmount ?? 0) > 0
    ? (priceOffer.quantAmount as number)
    : 1
  const derivedMultiplier = (priceOffer.quant === 'KGM' ? 1000 : 1) * quantAmount
  const multiplier =
    ('count_multiplier' in priceOffer ? priceOffer.count_multiplier : null)
    || derivedMultiplier

  if (price == null) return null

  return (amount * price) / multiplier
}
